// extracted by mini-css-extract-plugin
export default {"root":"IconPercent_root__EX3Yc"};